'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CustomSidebarOptions;

var _OptsToPath = require('signup-ui-core/static/js/constants/OptsToPath');

var _AllowedCustomOpts = require('signup-ui-core/constants/AllowedCustomOpts');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CustomSidebarOptions = (_CustomSidebarOptions = {}, _defineProperty(_CustomSidebarOptions, _OptsToPath.OptsToValue[_AllowedCustomOpts.MEETING_SIDEBAR], {
  imageName: 'meetingsImage',
  imageAlt: 'sales-meeting-2.png',
  sidebarMessage: 'core.accountDetails.sidebarDescription.virality.prospectBookMeetings'
}), _defineProperty(_CustomSidebarOptions, _OptsToPath.OptsToValue[_AllowedCustomOpts.LIVECHAT_SIDEBAR], {
  imageWidth: '40%',
  imageName: 'liveChatImage',
  imageAlt: 'live-chat-en.png',
  sidebarMessage: 'core.accountDetails.sidebarDescription.virality.livechat'
}), _defineProperty(_CustomSidebarOptions, _OptsToPath.OptsToValue[_AllowedCustomOpts.SALES_EXTENSION_SIDEBAR], {
  imageWidth: '55%',
  imageName: 'salesExtensionImage',
  imageAlt: 'sales-extension.png',
  sidebarMessage: 'core.accountDetails.sidebarDescription.virality.salesExtension'
}), _defineProperty(_CustomSidebarOptions, _OptsToPath.OptsToValue[_AllowedCustomOpts.LEADFLOWS_SIDEBAR], {
  imageName: 'leadflowsImage',
  imageAlt: 'lead-flows-en.png',
  sidebarMessage: 'core.accountDetails.sidebarDescription.virality.leadflows'
}), _defineProperty(_CustomSidebarOptions, _OptsToPath.OptsToValue[_AllowedCustomOpts.FORMS_SIDEBAR], {
  imageName: 'formsImage',
  imageAlt: 'forms-en.png',
  sidebarMessage: 'core.accountDetails.sidebarDescription.virality.forms'
}), _defineProperty(_CustomSidebarOptions, _OptsToPath.OptsToValue[_AllowedCustomOpts.DOCUMENTS_SIDEBAR], {
  imageName: 'documentsImage',
  imageAlt: 'documents-en.png',
  sidebarMessage: 'core.accountDetails.sidebarDescription.virality.documents'
}), _defineProperty(_CustomSidebarOptions, _OptsToPath.OptsToValue[_AllowedCustomOpts.CRM_EMAIL_SIDEBAR], {
  imageName: 'crmEmailImage',
  imageAlt: 'crm-email-en.png',
  sidebarMessage: 'core.accountDetails.sidebarDescription.virality.crmEmail'
}), _defineProperty(_CustomSidebarOptions, _OptsToPath.OptsToValue[_AllowedCustomOpts.MARKETING_FREE_EMAIL_SIDEBAR], {
  imageName: 'marketingFreeEmailImage',
  imageAlt: 'marketing-free-email-en.png',
  sidebarMessage: 'core.accountDetails.sidebarDescription.virality.marketingFreeEmail',
  isInternationalized: true
}), _defineProperty(_CustomSidebarOptions, '1', {
  sidebarMessage: 'core.accountDetails.sidebarDescription.trial.1'
}), _defineProperty(_CustomSidebarOptions, '2', {
  sidebarMessage: 'core.accountDetails.sidebarDescription.trial.2'
}), _defineProperty(_CustomSidebarOptions, '3', {
  sidebarMessage: 'core.accountDetails.sidebarDescription.trial.3'
}), _defineProperty(_CustomSidebarOptions, '4', {
  sidebarMessage: 'core.accountDetails.sidebarDescription.trial.4'
}), _defineProperty(_CustomSidebarOptions, '7', {
  sidebarMessage: 'core.accountDetails.sidebarDescription.trial.7'
}), _defineProperty(_CustomSidebarOptions, '8', {
  sidebarMessage: 'core.accountDetails.sidebarDescription.trial.8'
}), _defineProperty(_CustomSidebarOptions, '9', {
  sidebarMessage: 'core.accountDetails.sidebarDescription.trial.9'
}), _CustomSidebarOptions);

exports.default = CustomSidebarOptions;
module.exports = exports['default'];